import type { MetricEntrySeedInput } from './metric-registry';

export const WORKFORCE_REDUCTION_METRIC_REGISTRY_SEED_INPUTS: readonly MetricEntrySeedInput[] =
  Object.freeze([
    {
      metricKey: 'workforce_reduction_net_ebitda_opportunity_usd',
      measureIdentity: { measuredDimension: 'other', valueForm: 'amount', unitFamily: 'currency', normalizationBasis: 'none' },
      label: 'Workforce Reduction Scenario: workforce_reduction_net_ebitda_opportunity_usd',
      definition:
        'Governed decision-lever contribution the workforce-reduction module publishes into the composite; registered by the semantic ontology as a derived metric (extract-do-not-invent, module audit book 2026-07-10).',
      reconciliationRule:
        'Recomputed by workforce_reduction_net_ebitda_opportunity in the owning module; rolls into its target only through the objective-value bridge, never summed twice.',
      source:
        'apps/api/src/decision-modules/workforce-reduction/workforce-reduction.manifest.ts#contributionClaimId:workforce_reduction_net_ebitda_opportunity_usd',
      registryLayer: 'core',
      unit: 'USD',
      temporalType: 'flow',
      direction: 'higher_is_better',
      benchmarkable: false,
      sourceOfTruthClass: 'derived',
      ownerModuleId: 'workforce-reduction',
      sourceBindingKeys: ['workforce_reduction_net_ebitda_opportunity_usd'],
      targetMetricRef: { metricId: 'operating_income', registryVersion: 'objective_value_bridge_v1' },
      requiredEvidenceClasses: ['module_composite_contribution_v1'],
    },
    {
      metricKey: 'workforce_reduction_headcount_delta',
      measureIdentity: { measuredDimension: 'not_applicable', valueForm: 'change', unitFamily: 'count', normalizationBasis: 'none' },
      label: 'Workforce reduction headcount delta',
      definition:
        'Signed headcount change for the governed workforce reduction option.',
      reconciliationRule:
        'Must reconcile to the selected option headcount delta from the governed engine.',
      source:
        'apps/api/src/decision-modules/workforce-reduction/workforce-reduction.module-definition.ts#workforceMetricContracts:workforce_reduction_headcount_delta',
      registryLayer: 'core',
      unit: 'headcount',
      temporalType: 'count',
      direction: 'context',
      blendPolicy: { kind: 'never_blend' },
      aggregationRules: [],
      appliesTo: [],
      benchmarkable: false,
      sourceOfTruthClass: 'derived',
      ownerModuleId: 'workforce-reduction',
      sourceBindingKeys: ['workforce_reduction_headcount_delta'],
      requiredEvidenceClasses: [],
    },
  ]);
